import React from 'react'

import FormTitle, { FormTitleProps } from '../items/FormTitle'
import ItemBox from '../items/ItemBox'
import FormRefarensImage, {
  FormRefarensImageProps,
} from '../items/FormRefarensImage'

/**
 * Baseグループ
 */
const BaseGroup: React.FC<BaseGroupProps> = (props) => {
  return (
    <React.Fragment>
      <FormTitle
        isRequired={props.isRequired}
        isOption={props.isOption}
        title={props.title}
        description={props.description}
        caution={props.caution}
        hideTitle={props.hideTitle}
      />
      {props.image && <FormRefarensImage image={props.image} />}
      <ItemBox hasField={props.hasField}>{props.children}</ItemBox>
    </React.Fragment>
  )
}

export type BaseGroupProps = FormTitleProps &
  FormRefarensImageProps & {
    children: React.ReactNode
    hasField?: boolean
  }

export default React.memo<BaseGroupProps>(BaseGroup)
